<template>
  <div id="ContainerEmployeeInbox">
    <div class="row">
      <div class="col-12">
      <h4 class="page-title text-truncate">
					{{ $t('EmployeeInbox.EmployeeInbox') }}
			</h4>
        <div class="row">
          <b-col md="3" lg="3" sm="12">
            <MdEdit 
                v-bind:Label="$t('Shared.datefrom')"
                v-bind:TypeProp="'date'" 
                v-bind:Name="'DateFrom'"
                v-model="DateFrom"
                v-bind:Min="'1900-01-01'"
                v-bind:Max="'2200-12-31'"
                v-on:change="DateFromChange($event)"
                v-bind:OnPressEnter="SearchEmpInbox">                                     
            </MdEdit>
          </b-col>
          <b-col md="3" lg="3" sm="12">
            <MdEdit 
                v-bind:Label="$t('Shared.dateTo')"
                v-bind:TypeProp="'date'" 
                v-bind:Name="'DateTo'"
                v-model="DateTo"
                v-bind:Min="'1900-01-01'"
                v-bind:Max="'2200-12-31'"
                v-on:change="DateToChange($event)"
                v-bind:OnPressEnter="SearchEmpInbox" >                                     
            </MdEdit>
          </b-col>
          <b-col md="3" lg="3" sm="12">  
            <MdSelect
              v-bind:Label="$t('Shared.Type')"
              v-bind:Options="NoteTypesList"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'workFlowID'"
              v-bind:Model="ModelNoteType"
              v-bind:AllowEmpty="false"
              v-bind:Multiple="false"              
              :Input="ChangeDropDownNodeType"
              v-bind:isValid="this.isNoteTypeValid"
              />
          </b-col>
           <b-col md="3" lg="3" sm="12">  
            <MdSelect
              v-bind:Label="$t('Shared.Status')"
              v-bind:Options="statusOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:Model="StatusModel"
              v-bind:AllowEmpty="false"
              v-bind:Multiple="false"              
              :Input="ChangeDropDownNodeStatus"
              v-bind:isValid="this.isNoteTypeValid"
              />
          </b-col>         
        </div>
        <div class="row">
           <b-col md="3" lg="3" sm="12">  
            <MdSelect
              v-bind:Label="$tc('Shared.Patient')"
              v-bind:Options="patientOptions"
              v-bind:FieldDescription="'PatientName'"
              v-bind:FieldCode="'patientcode'"
              v-bind:Model="patient"
              v-bind:Multiple="true"              
              :Input="ChangeDropDownPatients"
              />
          </b-col>
          <b-col md="3" lg="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.Employee')"
              v-bind:Options="employeeOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:Model="employee"
              v-bind:Multiple="true"              
              :Input="ChangeDropDownEmployee"
              />
          </b-col>
          <b-col md="3" lg="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.Program')"
              v-bind:Options="programOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:Model="program"
              v-bind:Multiple="true"              
              :Input="ChangeDropDownProgram"
              />
          </b-col>
          <b-col md="3" lg="3" sm="12">  
            <MdSelect
              v-bind:Label="$t('EmployeeInbox.NoteName')"
              v-bind:Options="noteNameOptions"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'notesid'"
              v-bind:Model="noteName"
              v-bind:Multiple="true"              
              :Input="ChangeDropDownNoteName"
              />
          </b-col>         
        </div>            
        </div>
    </div>

              <b-row>
									<b-col md="12">
										<div class="text-center text-md-right mt-3">
											<button v-on:click="SearchEmpInbox"
												type="button"
												class="btn btn-primary btn-login mx-2 pull-right">
												{{ $t('Shared.Search') }}
											</button>
										</div>
									</b-col>
								</b-row>

    <div class="row">
      <div class="col-12 mt-2">
        <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
        <!--  <div v-if="showEmptyRecords" v-bind:style="emptyRecordsStyle" role="alert" aria-live="polite"><div class="text-center my-2">{{$t('MdTable.nRecShow')}}</div></div>




      <div v-for="(item,index) in this.items" :key="index">
          <div class="row dailyNotes">
            <div class="col-2 mt-1">          
              <span class="rounded-circle tableActionBTN tableBTNtext ikon med-play-mini" @click="ViewItem(item)" v-b-tooltip.hover.top="$t('Shared.View')"></span>
              <span class="rounded-circle tableActionBTN tableBTNtext ikon med-email-new" @click="MarkAs(item,'R')" v-if="item.messageStatus === 'N' || item.messageStatus === 'T'" v-b-tooltip.hover.top="$t('EmployeeInbox.MarkAsRead')"></span>
              <span class="rounded-circle tableActionBTN tableBTNtext ikon med-email-read" @click="MarkAs(item,'N')" v-if="item.messageStatus === 'R'" v-b-tooltip.hover.top="$t('EmployeeInbox.MarkAsNew')"></span>
              <span class="rounded-circle tableActionBTN tableBTNtext ikon med-bin"  @click="MarkAs(item,'T')" v-if="item.messageStatus !== 'T'" v-b-tooltip.hover.top="$t('EmployeeInbox.MarkAsTrash')"></span>
            
              
            </div>           
            <div class="col-2">
              <small>{{ $t('Shared.Date') }}</small><br>{{item.transDate}}
              <div style="height:1px;" v-if="item.messageStatus === 'N'"></div>
                        <div v-bind:class="item.messageStatus === 'N' ? 'chRstatusfinished':'chRstatus'" >
                            {{ item.statusDisplay}}
                        </div>
            </div>
            <div class="col-2">
              <small>{{ $tc('Shared.PatientName') }}</small><br>{{item.patientName }}
            </div>
             <div class="col-3">
              <small>{{ $tc('Shared.TherapistName') }}</small><br>{{item.therapistName }}
            </div>
            <div class="col-3">
              <small>{{ $t('Shared.Type') }}</small><br>{{item.type }}
            </div>
          </div>
          
          <div v-if="item.isVoid" class="alert alert-fill-warning" style="margin:10px 20px" role="alert">
                <i class="mdi mdi-alert-circle"></i> {{ $t('Msg.NoteVoied') }} {{item.reasonName}}
          </div>
          <div class="row dailyNotesContent">
            <div v-html="item.message" class="col-12"></div>
          </div>
        </div>-->
      
                      <MdTable 
                        v-bind:fields="fields"
                        v-bind:items="items"
                        v-bind:totalRows="totalRows"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                        v-bind:currentPage="currentPage"
                        v-bind:perPage="perPage"
                        v-bind:isReadOnlyIconView="ViewIconReadonly"
                        v-bind:pageOptions="pageOptions"
                        v-bind:refTable="'tableEmployeeInbox'"
                        v-bind:VisibleViewIcon="true"
                        v-bind:VisibleEmailNotificationNew="true"
                        v-bind:VisibleEmailNotificationRead="true"  
                        v-bind:IsEmployeeInbox="true"                      
                        v-bind:VisibleDeleteIcon="StatusModel.code !== 'Trash'" 
                        :EmailNotificationNewFun="MarkAs"
                        :EmailNotificationReadFun="MarkAs"
                        :viewIconEvent="ViewIcon"                       
                        :deleteIconEvent="DeleteIcon"           
                        :onRowSelected="onRowSelected"
                        :onFiltered="onFiltered"
                        :pageChanged="pageChanged"
                        :otherIcon="'printer-fill'"
                        :otherIconEvent="showReport"
                        :perPageFunction="PerPageFunction">
                      </MdTable>       


      </div>
    </div>

    <div class="space-actions"></div>
    <div class="page-actions">
      <MdButton
        v-bind:isReadOnly="items.length == 0"
        v-bind:Label="$t('Shared.Report')"
        v-bind:Name="'btnpatientlist'"
        v-bind:ClassProp="'secondary mx-2 btn-login'"
        v-on:click="showReportAll()"/>

        <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2" :disabled="items.length == 0">
						<b-dropdown-item v-on:click="exportToPdf()">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="emailPdf()">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="exportToCSV()">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="shareByEmailCSV()">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
				</b-dropdown>
    </div>
   <!-- <hr/>
    <div class="row mt-4">
      <div class="my-1 col-sm-7 col-md-6">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          @change="onChange"
          pills
          size="lg"
        ></b-pagination>
      </div>
      <div align="right" class="mr-2 col">
        {{ $t('Shared.Show') }}
        <b-form-select 
          v-model="perPage" 
          :options="options" 
          size="sm" 
          id="perPageSelect"
          v-bind:style="perPageStyle"
          @change="perPageChange">
        </b-form-select>
        {{ $t('Shared.Of') }} {{totalRows}}
      </div>
    </div>-->

    <div class="space-actions"></div>


    <EmployeeInboxNotesModal v-if="showNote"
        v-bind:Header="Header"       
        v-bind:ProgramCode="ProgramCode"
        @onCloseEmpNotesModal="onCloseNotesModal"
        @onCancelEmpNotesModal="onCancelEmpNotesModal"        
        v-bind:CategoryCode="CategoryCode"> 
    </EmployeeInboxNotesModal>

    <EmployeeInboxDischargeModal v-if="showDischarge"
      v-bind:TitleWindow="$t('EmployeeInbox.EmpInboxDischarge')"
      v-bind:RecordId="this.params.HeaderId"      
      v-bind:PatientCode="this.params.PatientCode">
    </EmployeeInboxDischargeModal>
    <EmployeeInboxRep v-if="isReportVisible" 
      :closeWindow="closeParamRepWindow"
      :dateFrom = this.DateFrom
      :dateTo = this.DateTo
      :type = this.ModelNoteType.workFlowID
      :status = this.StatusModel.code
      :patient = this.EmpInboxParam.PatientCodeList
      :employee = this.EmpInboxParam.TherapistCodeList
      :program = this.EmpInboxParam.ProgramCodeList
      :noteName = this.EmpInboxParam.NotesIdList
      :recNo = this.recNo
      />

    <CSVExportHelper
        ref="csvExportHelper"
        v-bind:conformSubject="$t('EmployeeInbox.EmployeeInbox')"
        v-bind:sendEmailAPI="'/EmployeeInbox/email'"
        v-bind:exportCsvAPI="'/EmployeeInbox/exportCSV'"
    >    
    </CSVExportHelper>

    <MdTreatmentPlanOutCome v-if="showTreatmentPlan"
      v-bind:HeaderObj="this.$attrs.Header"
      v-bind:CustomFrame="CustomFrame"
      v-bind:NotesIdByEmployeeInbox="NotesIdByEmployeeInbox"
      v-bind:ModalId="'TreatmentPlanModalEmployeeInbox'"
      v-bind:AdmissionRecordId="AdmissionRecId"
      v-bind:PatientCode="PatientCode"
      v-bind:isOpenInEmployeeInbox="true"
      v-bind:TitleWindow="this.$t('treatmentplan.Treatmentplan')"     
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    />

  </div>
</template>



<script>
//import EnumService from '@/services/enum.service' 
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import DailyNotesService from '@/services/dailynotes.service'
import Utils from '@/common/utils'
//import NotesTitlesService from '@/services/notestitles.service'
import LocalStorage from '@/services/storage.service';
//import UserPreference from "@/services/quickhelp.service"
import moment from "moment";
import PatientService from '@/services/patient.service'
import EmployeeService from '@/services/employee.service'
import ProgramService from '@/services/programs.services'
import GlobalService from '@/services/global.service'
import { EventBus } from '@/event-bus.js';  
import Permission from '@/common/Permission'
import ProviderService from '@/services/provider.service'
import EmployeeInbox from '@/services/employeeinbox.service'
import ClinicalService from '@/services/clinical.service'
import UserPreference from "@/services/quickhelp.service";

export default {

  /*beforeRouteEnter(to, from, next) {
        next(async vm => {
            const iUA = await vm.$store.state.isUseDailyNotes;
            if(iUA) next()
            else next('/accessdenied');
        }) 
  },*/

  mixins: [ShowMessage, DBFunctions, Permission],
  name: 'EmployeeInbox',

  data() {
    return {
        fields: [
          { key: 'transDate', sortable: true, label: this.$t('Shared.Date'), class: 'text-rigth' },  
          { key: 'patientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-rigth' },
          { key: 'patientCode', sortable: true, label: this.$t('Shared.PatientCode'), class: 'text-rigth' },
          { key: 'therapistName', sortable: true, label: this.$tc('Shared.TherapistName'), class: 'text-rigth' },
          { key: 'message', sortable: true, label: this.$t('Shared.Message'), class: 'text-rigth' },          
          ],

      EmployeeInboxDefaultDays:null,
      NotesIdByEmployeeInbox:"",
      DefaultDateTime:null,
      Loading:true,
      AdmissionRecId:"",
      PatientCode:"",
      Action:"",
      ShowMessageIsEmpty:false,
       pageOptions: [5, 10, 15 ],       
        filter: null,
        filterOn: [],
        items: [],
        showTreatmentPlan:false,
      DatasetNameSelected:"",
      showNote: false,
      showDischarge:false,
      isViewIcon:false,
      OptionsRightMenu:{
            visible:false,
            ItemsList:[],
            btnvisible:false,
            itemdisabled: false,
            PatientCode:''         
      },
       params:{      
          NotesID: "",
          HeaderId: "", 
          PatientCode: "",
          TherapyCode: "", 
          TransDate : "",
          AdmissionRecordID: "",
          IsVoid: ""
        },
      NotesTitlesParams:{
        SearchCriteria:'',
        PageNumber : 0,
        PageSize:0,      
      },
      EmpInboxParam:{
        SearchCriteria:'',
        PageNumber : 1,
        PageSize: 1,
        WorkflowID:"",
        DateFrom:null,
        DateTo:null,
        Status:"",
        PatientCodeList:[],
        TherapistCodeList:[],
        ProgramCodeList:[],
        NotesIdList:[],
      },
      DailyNotesParams:{
        SearchCriteria:'',
        PageNumber : 3,
        PageSize: 3,
        RecordId:null,
        NoteType:null        
      }, 
      ViewIconReadonly:false,
      isReadOnly: false,
      RegistrationInfo:{},
      NoteTypesList: [],
      ModelNoteType: {
        description:"",
        workFlowID:""      
      },
      DailyNotesList: [],

      EmpInboxList:[],
      UserId: LocalStorage.getUserId(),
      SelectedTypePreference: {'LastSelectedType':''},
      isNoteTypeValid: true,
      DailyNotesIsVoid: {'isVoid':'','reasonName':''},
      showReason: false,
      idDailyNote: null,
      canInsert: false,
      ProgramCode:"",
      CategoryCode:"",
      AddButtonDisabled: false,
      emptyRecordsStyle: {
        backgroundColor: '#CF0',
        fontWeight: 'bold !important',
        textTransform: 'uppercase',
        padding: '2px',
        borderRadius: '50px',
        animation: 'fadeOut 10s ease-in-out infinite'
      },
      showEmptyRecords: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 0, 
      Header:{},
      CustomFrame:"",
      
      options: [
        { value: 10, text: '10' },
        { value: 20, text: '20' },
        { value: 30, text: '30' },
        { value: 50, text: '50' },
      ],
      statusOptions: [
        { code: 'New', name: this.$t('EmployeeInbox.StOpts.new') },
        { code: 'Read', name: this.$t('EmployeeInbox.StOpts.read') },
        { code: 'Trash', name: this.$t('EmployeeInbox.StOpts.Trash') },
        { code: 'All', name: this.$t('Shared.All') },
      ],
      StatusModel:{code: 'New', name: this.$t('EmployeeInbox.StOpts.new')},
      parameter:{
        SearchCriteria:'',
        PageNumber : 0,
        PageSize:0,
        Status: true,       
      },
      patient: null,
      employee: null,
      program: null,
      noteName: null,
      patientOptions: [{}],
      employeeOptions: [{}],
      programOptions: [{}],
      noteNameOptions: [{}],
      perPageStyle: {
        width: 'auto'
      },
      recNoToReport: null,
      DateFrom: null,
      DateTo: null,
      isReportVisible: false,
      recNo: '',
      LoadselectedType:''
    }
  },

  methods: {

    closeParamRepWindow() {
      this.isReportVisible = false
      this.recNo = ''
    },

    showReport(item){
      this.recNo = item.recNo
      this.isReportVisible = true
    },

    onCodeConditionOk(){
      this.showTreatmentPlan = false;
      this.getEmpInboxList();
    },

    onCancel(){
      this.showTreatmentPlan = false;
      this.getEmpInboxList();
    },

    showReportAll(){
      this.isReportVisible = true
    },

  onRowSelected(){

  },

  PerPageFunction(value){
      this.perPage = value;
       this.currentPage = 1;
      this.getEmpInboxList();
  },

  pageChanged(page){
      this.currentPage = page;
      this.getEmpInboxList();
  },

  onFiltered(){

  },

  Download(){

  }, 

  isTypeDischarge(){
    return this.Action === 'LoadPatientDischarge';
  },
  
  IsTypeNote(){
    return this.Action === 'LoadClinicalNote' || this.Action === 'LoadCustomNotesID' || this.Action === 'LoadCustomNote' || this.Action === 'LoadDrClinicalNote';
  },

  VerifyAllTypes(){
    return this.Action === 'LoadClinicalNote' || this.Action === 'LoadCustomNotesID' || this.Action === 'LoadCustomNote' || this.Action === 'LoadDrClinicalNote' || this.Action === 'LoadPatientDischarge';
  },

async ViewIcon(item){ 
        this.params.NotesID = item.notesID;       
        this.params.PatientCode = item.patientCode;
        this.params.TransDate = this.transDate;
        this.params.HeaderId = item.recNo; 
        this.params.AdmissionRecordID = item.admissionRecordId; 

        this.AdmissionRecId = item.admissionRecordId;
        this.PatientCode = item.patientCode;   
        this.CustomFrame = item.customFrame;
        this.NotesIdByEmployeeInbox = item.notesID;

        if(this.IsTypeNote() && item.customFrame !== 'TFRMTREATMENTPLANNOTES' && item.customFrame !== 'TfmWileyTreatmentPlanNotes' ){
           await this.getClinicalNoteInfo();
          this.ProgramCode = this.Header.programCode
          this.CategoryCode = this.Header.transCode
          this.Header.Id = item.recNo; 
          this.Header.notesId = item.notesID;
          this.Header.Time = item.transDate
          this.showNote = true;
          setTimeout(() => {
            if (item.messageStatus == 'N') {
                this.MarkAs(item, 'R');
            }
          }, 100);
          
          
        }else if(this.IsTypeNote() && (item.customFrame === 'TFRMTREATMENTPLANNOTES' || item.customFrame === 'TfmWileyTreatmentPlanNotes')){
          this.showTreatmentPlan = true;
        }        
        else if(this.isTypeDischarge()){
          this.showDischarge = true;         
        }
        
        
},
EmailIcon(){

},

 DeleteIcon(item){  
  this.MarkAs(item,'T');
 },  
    
    ChangeDropDownPatients(value) {
      this.patient = value;
      this.EmpInboxParam.PatientCodeList = [];
      this.currentPage = 1;
      let tmp= [];
        value.forEach(function(item) {   
            tmp.push(item.patientcode.trim());               
        });            
        this.EmpInboxParam.PatientCodeList = tmp;
        this.getEmpInboxList();
    },

    ChangeDropDownEmployee(value) {
      this.employee = value;
      this.EmpInboxParam.TherapistCodeList = [];
      this.currentPage = 1;
      let tmp= [];
        value.forEach(function(item) {   
            tmp.push(item.code.trim());               
        });            
        this.EmpInboxParam.TherapistCodeList = tmp;
        this.getEmpInboxList();
    },

    ChangeDropDownProgram(value) {
       this.program = value;
      this.EmpInboxParam.ProgramCodeList = [];
      this.currentPage = 1;
      let tmp= [];
        value.forEach(function(item) {   
          tmp.push((item.code || '').trim());               
        });            
        this.EmpInboxParam.ProgramCodeList = tmp;
        this.getEmpInboxList();
    },

    ChangeDropDownNoteName(value) {
      this.noteName = value;
      this.EmpInboxParam.NotesIdList = [];
      this.currentPage = 1;
      let tmp= [];
        value.forEach(function(item) {   
          tmp.push((item.notesid || '').trim());             
        });            
        this.EmpInboxParam.NotesIdList = tmp;
        this.getEmpInboxList();
    },
    
    DateFromChange() {
       this.currentPage = 1;
    },

    DateToChange() {
      this.currentPage = 1;
    },

    perPageChange(value) {
      this.perPage = value;
      this.getEmpInboxList();
    },
    
    onChange(page) {
      this.currentPage = page;
      this.getEmpInboxList();
    },

    getNoteTypeName() {
      return this.findNoteTypeName(this.NoteTypesList, this.ModelNoteType).name
    },

    async ViewItem(/*item*/){  
       // this.active_el = item.formid;
        
     /*   await EventBus.$emit('CloseMdNote');
        
        this.params.NotesID = item.notesID;       
        this.params.PatientCode = item.patientCode;
        this.params.TransDate = this.transDate;

        this.params.HeaderId = item.recNo;       
        this.params.AdmissionRecordID = item.admissionRecordId;
        
      
        this.Header.recordid = item.admissionRecordId
        this.Header.title = item.processDescription
        this.Header.workflowRecID = item.workflowRecID
        this.Header.processRecID = item.processRecID
        this.Header.actionRecID = item.actionRecID
        this.Header.Id = item.workFlowNoteHeaderID 
        this.Header.notesId = item.actionFormID

        this.ProgramCode = this.Header.programCode
        this.CategoryCode = this.Header.transCode
        
        let patientInfo = {
          firstName:this.Header.patientFirstName, 
          lastName:this.Header.patientLastName, 
          patientCode:this.Header.patientCode
        }
        
        this.NotePatientInfo = patientInfo
        
        this.NoteTitle = this.Header.description*/       
    },


    MarkAs(item,status){
      let data = {
        messageType:item.type,
        messageKey:item.recNo,
        employeeCode:this.$store.state.employeeCode,
        status:status
      };
        EmployeeInbox.setStatus(data)
                .then((response) => {      
                    if (response.status == "200") {
                      this.getEmpInboxList();
                    }                   
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }                   
                }); 
    },

    setStatusDisplay(arr){
      for(var i = 0; i < arr.length; i++){
         if(arr[i].messageStatus === 'N')   
            arr[i].statusDisplay = this.$t('EmployeeInbox.StOpts.new');
        if(arr[i].messageStatus === 'R')
            arr[i].statusDisplay = this.$t('EmployeeInbox.StOpts.read') 
        if(arr[i].messageStatus === 'T')
            arr[i].statusDisplay = this.$t('EmployeeInbox.StOpts.Trash');  


     
        arr[i].VisibleNew = (arr[i].messageStatus === 'N' || arr[i].messageStatus === 'T') ? true : false;
        arr[i].VisibleRead = arr[i].messageStatus === 'R' ? true : false;
        arr[i].VisibleTrash = arr[i].messageStatus !== 'T' ? true : false;
      }
    },

    AllAreTrash(arr){
      let count = 0;
      for(var i = 0; i < arr.length; i++){
            if(arr[i].messageStatus !== 'T'){
              count++;
            }
      }

      return count === arr.length;
    },
    

    async getEmpInboxList() {
      this.$emit("load", true);
      this.EmpInboxParam.PageNumber = this.currentPage;
      this.EmpInboxParam.PageSize = this.perPage;
      this.EmpInboxParam.DateFrom = this.DateFrom;
      this.EmpInboxParam.DateTo = this.DateTo;
      this.EmpInboxParam.Status = this.StatusModel.code;   
      await EmployeeInbox.getAll(this.EmpInboxParam)
        .then((response) => {
          if (response.status == "200" && response.data) {           
           // this.EmpInboxList = response.data;
            this.items = response.data;
            let headerString = response.headers["x-pagination"];
            let pagination = JSON.parse(headerString);
            this.totalRows = pagination.TotalCount;
            this.showEmptyRecords = response.data && response.data.length == 0 ? true : false;
            this.ShowMessageIsEmpty = response.data && response.data.length == 0 ? true : false;
           
            this.setStatusDisplay(this.items);


           /* this.items.push({daysOverDue:153,
                        message:"CNPCC Admissions Risk Assessment for patient aaa123456789aa, aa1 Medical record 2306679    is final SUPPORT, MEDEZ",
                        messageStatus:"N",
                        statusDisplay:"New",
                        notesID:"345         ",
                        patientCode: "2306679   ",
                        patientName: "aaa123456789aa, aa1",
                        recNo:"8210948AB8E4E89F",
                        therapistCode: "MEDEZ   ",
                        therapistName: "SUPPORT, MEDEZ",
                        transDate: "2025-01-23T00:00:00",
                        type:"Final Notes"
                      });*/



            this.items.forEach(function (element) {              
              if (element.transDate)
                element.transDate = moment(element.transDate).format("ddd, ll");
                //element.transDate = Utils.formatterDateToString(element.transDate);                                    
            });
            this.$emit("load", false);
          }
          this.$emit("load", false);
        })
        .catch((error) => {
          this.$emit("load", false);
          if (!error.response) {
            // network error
            this.showMessage(
              this.$tc('Msg.Error'),
              this.$t('Msg.retrieveInfo'),
              "error"
            );
          } else {
            this.showMessage(this.$tc('Msg.Error'), error, "error");
          }
        });
    },

    async getDateTime() {           
            await GlobalService
                .getDateTime()
                .then((response) => {      
                    if (response.data) {
                      this.DefaultDateTime = response.data;
                      this.DateTo = Utils.formatterDate(this.DefaultDateTime);
                    }                   
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }                   
                }); 
        },

        async getEmpTypes(LastSelectedType) {           
            await EmployeeInbox
                .getEmployeeTypes()
                .then((response) => {      
                    if (response.data) {
                      this.NoteTypesList = response.data;
                
                      if(this.NoteTypesList.length > 0){
                        const found = this.NoteTypesList.find(item => item.workFlowID.trim() === LastSelectedType.trim());
                        if (found) {
                          this.ModelNoteType.description = found.description;
                          this.ModelNoteType.workFlowID = found.workFlowID;  
                          this.DatasetNameSelected = found.datasetName;
                          this.EmpInboxParam.WorkflowID = found.workFlowID;
                        } else {
                          this.ModelNoteType.description = this.NoteTypesList[0].description;
                          this.ModelNoteType.workFlowID = this.NoteTypesList[0].workFlowID;  
                          this.DatasetNameSelected = this.NoteTypesList[0].datasetName; 
                          this.EmpInboxParam.WorkflowID = this.NoteTypesList[0].workFlowID;
                         
                        }
                        const action = found && found.action || this.NoteTypesList[0]?.action;
                        this.Action = action?.name;
                        this.ViewIconReadonly = !action;

                        if(!this.VerifyAllTypes()){
                          this.ViewIconReadonly = true;
                        }
                      
                      }
                    }                   
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }                   
                }); 
        },


      getNoteTypes(){
          this.parameter.CustomFrameList = ['TFMDFORMDESIGNERRENDERING','TFRMTREATMENTPLANNOTES','TfmWileyTreatmentPlanNotes'];
          this.parameter.showAll = false;

          GlobalService.getNoteTypesByCustomFrameList(this.parameter)
          .then((response) => { 
            if(response.data && response.data.length > 0){   
              this.noteNameOptions = response.data;             
            }
          })
          .catch(error => {
            if (!error.response) {
            // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
            } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
          });  
      },


async getProvider(){
      await ProviderService.get(this.$store.state.providerCode)
            .then((response) => {      
               if (response.status == '200' && response.data) { 
                  this.EmployeeInboxDefaultDays = response.data.employeeInboxDefaultDays;  

                  if(this.EmployeeInboxDefaultDays !== null && this.EmployeeInboxDefaultDays > 0){
                       this.DateFrom = Utils.formatterDate(moment(this.DefaultDateTime).subtract(this.EmployeeInboxDefaultDays, 'days'));                   
                  }else{
                    this.DateFrom = Utils.formatterDate(moment(this.DefaultDateTime));                   
                  }
               }  
         })
         .catch(error => { 
          if (!error.response) {                      
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    }                      
                    else if(error.response.status === 400 ){
                      this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                    } else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }                  
         });
             
    },


SearchEmpInbox(){
  this.getEmpInboxList();
},


 async getClinicalNoteInfo(){
      await ClinicalService.getClinicalNoteInfo(this.params)
          .then((response) => {              
            if(response.data){
              this.Header = response.data;               
            }
            this.Load = false;
          })
          .catch(error => {
            if (error.response) {
              this.Load = false;
              this.showMessage(this.$tc('Msg.Error'),error,"error");
            } 
          });  
    },

    Edit(item) {
      this.emitDataforFavorites();  
     // EventBus.$emit('onUpdatedMenu', ''); 

      //TODO, paramaters => id: this.$route.params.id, recordid: this.$route.params.recordid, NOT EXIST
      this.$router.push({ name: "dailynote-details", params: { id: this.$route.params.id, recordid: this.$route.params.recordid, dailynoteid: item.recNo, noteTypeName: item.noteTypeName } });
    },

    Void(id, isVoid) {
      this.idDailyNote = id

      if (!isVoid)
        this.showReason = true;
      if (isVoid)
        this.setIsVoid('N','')
    },

    findNoteTypeName (array, code) {
      return array.find(element => element.code === code) ?? -1;
    },

    getListing() {
      this.$emit('load', true);
      this.currentPage = 1
      this.getDailyNotes()
    },

    async setIsVoid(value, reason) {
      this.DailyNotesIsVoid.isVoid = value
      this.DailyNotesIsVoid.reasonName = reason
      this.$emit('load', true);
      await this.UpdateIsVoid(this.idDailyNote)
      this.getDailyNotes()
    },

    ChangeDropDownNodeStatus(value){
      this.EmpInboxParam.Status = "";
      this.StatusModel = value ? value : {code:"",name:""};
      this.EmpInboxParam.Status = value ? value.code : "";
      this.currentPage = 1;
       this.SearchEmpInbox();
    },

    ChangeDropDownNodeType(value) {
      this.ModelNoteType = value;
      this.EmpInboxParam.WorkflowID = value ? value.workFlowID : '';
      this.DatasetNameSelected = value ? value.datasetName:""; 

      this.UpdatePreference(this.EmpInboxParam.WorkflowID)

      if(value.action !== null){
        this.Action = value.action.name;
        this.ViewIconReadonly = false;
      }else{
        this.ViewIconReadonly = true;
      }

      if(!this.VerifyAllTypes()){
        this.ViewIconReadonly = true;
      }
      this.currentPage = 1;
      this.SearchEmpInbox();
      
    },

  async getUserPreference() {
      await UserPreference.getQhUserPreference(this.UserId)
        .then((response) => {
          if (response.data && response.data.length > 0) {
            const LastSelectedType = response.data[0].lastSelectedType ;
           
            if (LastSelectedType) {
              this.LoadselectedType = LastSelectedType
            }
          } 
        })
        .catch((error) => {
          if (error.errorMessage) {
            this.showMessage(this.$tc('Msg.Error'), error, "error");
          }
        });
    },
   

   UpdatePreference(value){
      this.SelectedTypePreference.LastSelectedType = value
      UserPreference.UpdateLastSelectedType(this.UserId, this.SelectedTypePreference)
        .catch((error) => {
          if (!error.response) {
            this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.NotAbleToUpdate'),"error");
          }          
          else if (error.response.data && error.response.data.errorMessage) {
            this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
          }
          else {
            this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
          }
        });
    },

    async UpdateIsVoid(id){
      await DailyNotesService.updateIsVoid(id, this.DailyNotesIsVoid)
        .catch((error) => {
          if (!error.response) {
            this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.NotAbleToUpdate'),"error");
          }          
          else if (error.response.data && error.response.data.errorMessage) {
            this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
          }
          else {
            this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
          }
        });
    },

    getPatients() { 
      PatientService.getAll(this.parameter)
        .then((response) => {
          if(response.status == '200' && response.data && response.data.length > 0){
            this.patientOptions = response.data;
            this.patientOptions.forEach(function(element) {
              element.PatientName = element.firstname + " " + element.lastname + " - " + element.patientcode;   
            });
          }
        })
        .catch(error => {
          if (!error.response) {
            // network error
            this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
          } else {
            this.showMessage(this.$tc('Msg.Error'),error,"error");
          }
        });
    },

    getAllEmployee(){
      EmployeeService.getAllEmployees()
          .then((response) => { 
            if(response.data && response.data.length > 0){   
              let arr = response.data;
              this.employeeOptions = arr;
            }
          })
          .catch(error => {
            if (!error.response) {
            // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
            } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
          });  
    },

    getPrograms(){
      ProgramService.getAll(this.parameter)
        .then((response) => { 
          if(response.data && response.data.length > 0){   
            this.programOptions = response.data;
          }
        })
        .catch(error => {
            if (!error.response) {
            // network error
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
            } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
        });  
    },

    exportToCSV() {
        this.EmpInboxParam.DateFrom = this.DateFrom;
        this.EmpInboxParam.DateTo = this.DateTo;
        this.EmpInboxParam.Status = this.StatusModel.code;   

        this.$refs.csvExportHelper.exportCSV(this.EmpInboxParam);
    },

    shareByEmailCSV() {   
        this.EmpInboxParam.DateFrom = this.DateFrom;
        this.EmpInboxParam.DateTo = this.DateTo;
        this.EmpInboxParam.Status = this.StatusModel.code; 

        this.$refs.csvExportHelper.emailCSV(this.EmpInboxParam);
    },
    
    exportToPdf() {
        let reportParams = [];
        reportParams.push({ paramName: 'dateFrom', paramValue: this.DateFrom});
        reportParams.push({ paramName: 'dateTo', paramValue: this.DateTo});
        reportParams.push({ paramName: 'type', paramValue: this.ModelNoteType.workFlowID.trim()});
        reportParams.push({ paramName: 'status', paramValue: this.StatusModel.code});
        reportParams.push({ paramName: 'patient', paramValue: this.EmpInboxParam.PatientCodeList});
        reportParams.push({ paramName: 'employee', paramValue: this.EmpInboxParam.TherapistCodeList});
        reportParams.push({ paramName: 'program', paramValue: this.EmpInboxParam.ProgramCodeList});
        reportParams.push({ paramName: 'noteName', paramValue: this.EmpInboxParam.NotesIdList});
        reportParams.push({ paramName: 'recNo', paramValue: this.recNo});

        this.$refs.csvExportHelper.exportToPdf('EmployeeInbox', true, false, reportParams);
    },

    emailPdf() {
        let reportParams = [];
        reportParams.push({ paramName: 'dateFrom', paramValue: this.DateFrom});
        reportParams.push({ paramName: 'dateTo', paramValue: this.DateTo});
        reportParams.push({ paramName: 'type', paramValue: this.ModelNoteType.workFlowID.trim()});
        reportParams.push({ paramName: 'status', paramValue: this.StatusModel.code});
        reportParams.push({ paramName: 'patient', paramValue: this.EmpInboxParam.PatientCodeList});
        reportParams.push({ paramName: 'employee', paramValue: this.EmpInboxParam.TherapistCodeList});
        reportParams.push({ paramName: 'program', paramValue: this.EmpInboxParam.ProgramCodeList});
        reportParams.push({ paramName: 'noteName', paramValue: this.EmpInboxParam.NotesIdList});
        reportParams.push({ paramName: 'recNo', paramValue: this.recNo});

        this.$refs.csvExportHelper.emailPdf('EmployeeInbox', true, false, reportParams);
    },

    async onLoad(){
        const allPromise = Promise.all([
            this.getPatients(), 
            this.getNoteTypes(), 
            this.getAllEmployee(), 
            this.getPrograms(),
            ]
          );
        allPromise.then(async () => {
          await this.getUserPreference();
          await this.getEmpTypes(this.LoadselectedType);
          await this.getEmpInboxList();
        });   
    },

    onCloseNotesModal(){    
        this.showNote = false;
        this.showDischarge = false;
        this.getEmpInboxList();
    },

    onCancelEmpNotesModal(){
      this.showNote = false;
      this.showDischarge = false;
      this.getEmpInboxList();
    },
  },

 created(){   
    EventBus.$on("CloseMdNote", function () {
        this.showNote = false;
        this.showDischarge = false;       
        this.getEmpInboxList();
    }.bind(this));

   /* EventBus.$on("CloseModalOutCome", function () {   
      this.showTreatmentPlan = false;
      this.getEmpInboxList();
    }.bind(this)); */

    /* EventBus.$on("CloseModalOutCome", function () {
      console.log("CloseNote");
      }.bind(this));*/
  },

  async mounted() {
    if (!this.IsAccessAllowed()) {
        return;
    }

   // this.$emit('load', true);
    await this.getDateTime();
    await this.getProvider();
    this.OptionsRightMenu.visible = false;
    this.OptionsRightMenu.ItemsList = [];
    this.$emit('getVisibleMenu', this.OptionsRightMenu);
    this.$emit('getBtnRightMenu', this.OptionsRightMenu);
    await this.onLoad();
    
   
    EventBus.$on("ShowWeel", function (isShow) { 
        isShow ? this.$emit('load', true) : this.$emit('load', false);     
     }.bind(this));
  },

  destroyed(){
    this.$store.commit('setWrotePasswordNotes',false);
    this.$store.commit('setWrotePasswordCosignerNotes','');
}
};

</script>